import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createCollectionWholesalerDocument = async (details) => {
    // get the reference to the Firestore document
    const uniqueId = uuidv4();
    const docRef = db.doc(`/CollectionWholesaler/${uniqueId}`);

    //create user object
    details.uniqueId = uniqueId;
    details.postedDateTime = new Date();

    // write to Cloud Firestore
    await docRef.set(details);
    const getBackCollectionWholesaler = await db.doc(`/CollectionWholesaler/${uniqueId}`);
    await getBackCollectionWholesaler.get().then(result => {
        if(result?.id) {
            return true;
        } else {
            return false
        }
    });
    
}

export const getCollectionWholesalerDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('CollectionWholesaler').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getCollectionWholesalerDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('CollectionWholesaler').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getAllCollectionWholesalerDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('CollectionWholesaler').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const updateCollectionWholesalerDocument = async (payemnt) => {
    const docRef = db.doc(`/CollectionWholesaler/${payemnt._id}`);
    return docRef.update(payemnt);
}

export const uploadExcelPdfInvoiceDocument = async (details) => {
    // get the reference to the Firestore document
    const uniqueId = uuidv4();
    const docRef = db.doc(`/ExcelPdfInvoice/${uniqueId}`);

    //create user object
    details.uniqueId = uniqueId;
    details.postedDateTime = new Date();

    // write to Cloud Firestore
    await docRef.set(details);
    const getExcelPdfInvoice = await db.doc(`/ExcelPdfInvoice/${uniqueId}`);
    await getExcelPdfInvoice.get().then(result => {
        if(result?.id) {
            return true;
        } else {
            return false
        }
    });
    
}

export const getExcelPdfInvoiceDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('ExcelPdfInvoice').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getExcelPdfInvoiceDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('ExcelPdfInvoice').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getAllExcelPdfInvoiceDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('ExcelPdfInvoice').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const uploadInvoiceDocument = (filePath, file) => {
    return new Promise((resolve, reject) => {
        // create file reference
        const fileRef = storage.ref().child(filePath);

        // upload task
        const uploadTask = fileRef.put(file);
        uploadTask.on('state_changed', null, (error) => reject(error), () => {
            resolve(uploadTask.snapshot.ref);
        });
    });
}

export const getDownloadUrlFromFullPath = (filePath) => {
    return storage.ref().child(filePath).getDownloadURL();
}